﻿<template>
	<div v-if="atc"
		 v-html="atc"
		 class="ccs-logo-product-atc"
		 :class="{ 'ccs-logo-product-atc_default': !isCustom }"
		 @click="$emit('click')">
	</div>
</template>

<script>
	export default {
		props: {
			atc: String
		},

		inject: ["options"],

		data() {
			return {
				isCustom: this.options.isCustomAtc
			}
		}
	}
</script>

<style>
	.ccs-logo-recommends .ccs-logo-product-atc_default a {
		display: inline-block;
		padding: .65em 1.05em;
		background: #999;
		color: #FFF;
		font-size: 1.15em;
		font-weight: bold;
		text-decoration: none;
		line-height: 1;
	}

	/* get rid after cross-sell settings refactoring */
	.ccs-logo-recommends [data-logo-addtocart] {
		display: block;
	}
</style>